const styles = (theme) => ({
  root: {},
  totalLabel: {
    textAlign: 'left',
    marginBottom: theme.spacing.unit * 2,
  },
  totalValue: {
    textAlign: 'right',
  },
  totalText: {
    fontSize: '1.250rem',
    fontWeight: 500,
  },
  tableCellHead: {
    fontSize: '1.0625rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.125rem',
    },
  },
  tableCell: {
    fontSize: '0.9375rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.0625rem',
    },
  },
  paginator: {
    marginTop: theme.spacing.unit * 3,
  }
});

export default styles;
